import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useNotesStore } from '../store';
import Editor from '../components/Editor';
import FileUpload from '../components/FileUpload';

export default function NoteView() {
  const { id } = useParams();
  const { fetchNote, currentNote, isLoading } = useNotesStore();
  const [showFiles, setShowFiles] = React.useState(false);

  useEffect(() => {
    if (id) {
      fetchNote(id);
    }
  }, [id]);

  if (isLoading && !currentNote) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-accent"></div>
      </div>
    );
  }

  if (!id) {
    return (
      <div className="flex items-center justify-center h-full text-dark-400">
        Select a note from the sidebar
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col">
      {/* Editor */}
      <div className="flex-1 min-h-0">
        <Editor noteId={id} />
      </div>

      {/* Files section toggle */}
      <div className="border-t border-dark-700">
        <button
          onClick={() => setShowFiles(!showFiles)}
          className="w-full px-4 py-2 text-sm text-dark-400 hover:text-dark-200 hover:bg-dark-800 transition-colors"
        >
          {showFiles ? 'Hide' : 'Show'} Files
        </button>

        {showFiles && (
          <div className="p-4 border-t border-dark-700 bg-dark-800/50">
            <FileUpload noteId={id} />
          </div>
        )}
      </div>
    </div>
  );
}
